import styled, { css } from 'styled-components/macro'
import { padding } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'
import palette from 'src/designSystem/variables/palette'

export const DateRangeWrapper = styled.div<{
  disabled?: boolean
  $width?: string
  $single?: boolean
}>`
  display: inline-flex;
  flex-direction: column;
  position: relative;
  width: ${({ $width }) => $width ?? '330px'};
  max-width: 450px;

  .rdrDateDisplayWrapper {
    height: 33px;
    border: 1px solid ${themeGet('colors.border.neutral.light')};
    border-radius: 20px;
    background-color: white;
    opacity: ${(props) => (props.disabled ? '0.5' : '1')};

    .rdrDateDisplay {
      height: 100%;
      margin: 0;
      padding: 4px 8px;

      .rdrDateInput {
        height: 100%;
        box-shadow: none;

        &:nth-child(2) {
          position: relative;
          margin-left: 17px;
          display: ${({ $single }) => ($single ? 'none' : 'block')};

          &::before {
            content: '';
            position: absolute;
            /*
              Place in between the two .rdrDateInput elements
              Shift to the left 1px to account for parent's border
              Shift to the left 9px to reach middle of margin
            */
            left: -10px;
            top: 5px;
            height: 60%;
            border-left: 1px solid ${palette.neutral[900]};
          }
        }

        input {
          height: 100%;
          color: ${themeGet('colors.text.default')};
          font-weight: 400;
          font-size: 14px;
          &::placeholder {
            color: ${themeGet('colors.text.default')};
            font-weight: ${themeGet('fontWeights.medium')};
          }
        }
      }
    }
  }

  ${({ $single }) =>
    $single &&
    css`
      .rdrDateDisplay .rdrDateInput:first-child {
        display: block;
        margin: 0;
      }
    `}
`

export const DateRangeEditButton = styled.button.attrs({
  type: 'button',
})`
  position: absolute;
  z-index: 1;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  background-color: transparent;
  border: none;
  border-radius: 20px;
`

export const BlurBackground = styled.div`
  position: fixed;
  z-index: 9999;
  top: 0;
  width: 100vw;
  height: 100vh;
  background-color: black;
  opacity: 0.5;
`

export const DateRangeModalContainer = styled.section`
  position: fixed;
  z-index: 10000;
  top: 0;
  width: 100vw;
  height: 100vh;
`

export const DateModalBody = styled.article`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  width: fit-content;
  margin: 25vh auto;
  background-color: white;
  border-radius: 4px;
  overflow: clip;
  .rdrCalendarWrapper {
    border-radius: 4px;
    overflow: clip;

    .rdrMonth .rdrDays .rdrDay {
      .rdrInRange,
      .rdrSelected,
      .rdrInRange,
      .rdrStartEdge,
      .rdrEndEdge,
      .rdrDayStartPreview,
      .rdrDayInPreview,
      .rdrDayEndPreview {
        color: ${themeGet('colors.fill.primary.extraDark')}!important;
      }

      &.rdrDayHovered,
      .rdrDayStartPreview,
      .rdrDayInPreview,
      .rdrDayEndPreview {
        color: ${themeGet('colors.fill.primary.light')}!important;
      }

      &.rdrDayToday .rdrDayNumber span:after {
        background: ${themeGet('colors.fill.primary.extraDark')}!important;
      }
    }

    &.rdrDateRangeWrapper {
      .rdrDateDisplayWrapper
        .rdrDateDisplay
        .rdrDateInput.rdrDateDisplayItemActive {
        border-color: ${themeGet('colors.border.primary.base')};
      }
    }

    &:not(.rdrDateRangeWrapper) .rdrDateDisplayWrapper {
      .rdrDateDisplay .rdrDateInput {
        &:first-child {
          display: block;
        }
        &:nth-child(2) {
          display: none;
          margin: 0;
          &::before {
            display: none;
          }
        }
      }
    }
  }
`

export const DateModalFooter = styled.footer.attrs({
  p: 'm',
})`
  ${padding}
  display: inline-flex;
  justify-content: flex-end;
  width: 100%;
`

export const TimeInputWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 20px;
  padding: 0 16px 16px;
  width: 100%;
`

export const TimeField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

  label {
    font-size: 12px;
    color: ${themeGet('colors.text.muted')};
    font-weight: 500;
  }
`

export const TimeInput = styled.input`
  padding: 4px 8px;
  border: 1px solid ${themeGet('colors.border.neutral.light')};
  border-radius: 4px;
  font-size: 14px;
  color: ${themeGet('colors.text.default')};

  &:focus {
    outline: none;
    border-color: ${themeGet('colors.border.primary.base')};
  }
`
